import {
  GET_ACTIVITY_PERFORMANCE_ASSET_LIST,
  GET_ASSETS,
  GET_ISO_CODE,
} from "../constants";
import { ApiCall } from "../../utils/index";

export const getAssets = (cb, debouncedHandleSearch, page, row_count, sortField, sortOrder) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    let url = "/assetType/byCompany"

    if(page) {
      const searchParam = debouncedHandleSearch ? `search=${debouncedHandleSearch}&` : "";
      const params = `?${searchParam}page=${page}&page_size=${row_count}&sort_by=${sortField}&sort_order=${sortOrder}`;
      url = url + params
    }

    const result = await ApiCall.get(url, token);
    dispatch({ type: GET_ASSETS, payload: result.data });
    cb(result);
  } catch (error) {
    cb(error);
  }
};

export const createAssets = (payload, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.post("/assetType/", payload, token);
    cb(result);
  } catch (error) {
    cb(error);
  }
};

export const updateAsset = (payload, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.patch(`/assetType/`, payload, token);

    cb(result);
  } catch (error) {
    cb(error);
  }
};

export const deleteAsset = (id, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.delete(`/assetType/${id}`, token);
    cb(result);
  } catch (error) {
    cb(error);
  }
};

export const getAllAssetByActivityAssignmentId =
  (activity_assignment_id) => async (dispatch, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.get(
        `/assetentry/${activity_assignment_id}`,
        token
      );
      dispatch({
        type: GET_ACTIVITY_PERFORMANCE_ASSET_LIST,
        payload: result.data,
      });
    } catch (error) {}
  };

export const getIsoData = () => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await ApiCall.get("/master/iso", token);
    dispatch({type: GET_ISO_CODE, payload: result.data});
  } catch (error) {}
};
